module.exports = __webpack_public_path__ + "static/img/yidi3.61185e70.webp";